import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/40">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                五一<span className="text-primary-500">黑料</span>网
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              汇聚全网最热51黑料吃瓜资源，网红擦边反差视频、每日大赛实时追踪与黑料门事件深度曝光。认准五一黑料网权威发布。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-300/40 text-foreground-500 hover:text-primary-500 hover:border-primary-500/40 transition-colors" title="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-300/40 text-foreground-500 hover:text-primary-500 hover:border-primary-500/40 transition-colors" title="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-300/40 text-foreground-500 hover:text-primary-500 hover:border-primary-500/40 transition-colors" title="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-300/40 text-foreground-500 hover:text-primary-500 hover:border-primary-500/40 transition-colors" title="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  商务合作
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/40">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 五一黑料网 51heiliao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}